import { render } from "./BrowserWarning.vue?vue&type=template&id=68d71474&scoped=true"
import script from "./BrowserWarning.vue?vue&type=script&lang=js"
export * from "./BrowserWarning.vue?vue&type=script&lang=js"

import "./BrowserWarning.vue?vue&type=style&index=0&id=68d71474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d71474"]])

export default __exports__